import { FC, useState, createContext, useContext, useCallback } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const initialState: QueryState = {
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'pessoa.nome', order: 'asc' }],
  }

  const [state, setState] = useState<QueryState>(initialState)

  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }))
  }, [])

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
